// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
 



.bi-tableau-section {
  width: 100%;
  height: calc(100vh - 108px);  /* Adjust 108px to match your header height exactly */
  min-height: 350px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
 
.tableau-viz-responsive {
  width: 100%;
  height: 100%;
  min-height: 350px;
}
 
/* .dashboard-container {
  width: 99%;
  max-width: 2200px;
  height: 100vh;
  margin: 0 auto;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: -10px;
  position: relative;
  transform: scale(1);
  transform-origin: top left;
} */
 
.dashboard-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 4px;
 
}
.header-main{
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
 
}
 
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
 
.header-right-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
 
.avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
}
 
.chat-button-container {
  display: flex;
  align-items: center;
}
 
.back-to-dashboard-button:disabled {
  pointer-events: none;    
  opacity: 0.5;            
  cursor: not-allowed;    
}
 
 
/* Overall Wrapper to force a horizontal layout */
.dashboard-wrapper {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}
 
/* Dashboard Container on the left */
.dashboard-container {

  flex-grow: 1;
  width: 100%; /* 100% when chatbot isn't open */
  height: 100vh;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease-in-out;
}
 
/* When chatbot is open, shrink dashboard to 70% */
.dashboard-container.shrink-dashboard {
  width: 70%;
}
 
/* Chatbot window on the right */
.floating-chat-window {
  width: 30%;
  height: 100vh;
  background-color: #fcfcfc;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  border-left: 1px solid #ccc;
  transition: width 0.3s ease-in-out;
}
 
/* Floating Chat Toggle Button - fixed at bottom-right */
.floating-chat-toggle {
  position: fixed;
  bottom: 20px;
  right: 25px;
  z-index: 1000;
  background: linear-gradient(to right, #4b6cb7, #182848);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  width: 60px;
  height: 60px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 0.3s;
}
 
.floating-chat-toggle:hover {
  background: linear-gradient(to right, #182848, #4b6cb7);
}

.chatbot-body {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.floating-chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.floating-chat-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease-in-out;
}

.floating-chat-close:hover {
  color: #000;
}

/* .floating-chat-toggle {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;
  background-color: #1e3a8a;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}

.floating-chat-toggle::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 60px; 
  right: 0;
  transform: translateX(30%) translateY(0); 
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
}

.floating-chat-toggle:hover::after {
  opacity: 1;
} */ 

.floating-chat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  /* ensure the container can capture hover */
}

.floating-chat-toggle {
  background-color: #1e40af;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 14px;
  font-size: 22px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: transform 0.2s ease;
}
.floating-chat-toggle:hover {
  transform: scale(1.05);
}

.tooltip {
  position: absolute;
  bottom: 70px;    /* adjust vertical distance above the button */
  right: 0;
  background-color: #496cdd;
  color: white;
  padding: 8px 14px;
  font-size: 13px;
  border-radius: 20px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  
  opacity: 0;
  pointer-events: none;
  transform: translateY(8px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* <-- This is the fix: hover on container, not on the button */
.floating-chat-container:hover .tooltip {
  opacity: 1;
  transform: translateY(0);
}




.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  margin-bottom: 4px;
}

/* New: left group for dropdown/add */
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
}

/* New: fixed center title */
.main-title-fixed {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  white-space: nowrap;
  z-index: 0;
}

/* Keep right section aligned */
.header-right-container {
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 1;
}






/* body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.dashboard-wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
  transition: all 0.3s ease;
  position: relative;
}

.dashboard-container {
  flex-shrink: 0;
  width: 100%;
  max-width: 2200px;
  height: 100vh;
  margin: 0 auto;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
}

/* Shrink dashboard when chat is open */
/* .dashboard-wrapper.chat-open .dashboard-container {
  width: 70% !important;
}

.dashboard-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 4px;
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-right-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
}

.chat-button-container {
  display: flex;
  align-items: center;
}

.back-to-dashboard-button:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

/* Floating 💬 button */
/* .floating-chat-toggle {
  position: fixed;
  bottom: 20px;
  right: 25px;
  z-index: 1000;
  background: linear-gradient(to right, #4b6cb7, #182848);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  width: 60px;
  height: 60px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 0.3s;
}

.floating-chat-toggle:hover {
  background: linear-gradient(to right, #182848, #4b6cb7);
}

/* Full ChatWindow embedded on right 30% */
/* .floating-chat-window {
  width: 30%;
  height: 100vh;
  background-color: #fcfcfc;
  z-index: 999;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #ccc;
} */ 
`, "",{"version":3,"sources":["webpack://./src/components/styles/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;;;;AAKA;EACE,WAAW;EACX,2BAA2B,GAAG,qDAAqD;EACnF,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;;AAEpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;;EAEE,YAAY;EACZ,WAAW,EAAE,iCAAiC;EAC9C,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uDAAuD;EACvD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsCG;;AAEH;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY,KAAK,8CAA8C;EAC/D,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;;EAEtC,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,wBAAwB;AAC1B;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;;;;;;AAOA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;uCAkCuC;AACvC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;uBA4DuB;AACvB;;;;;;;;;;;;;;;;;;;;;0CAqB0C;AAC1C;;;;;;;;;;GAUG","sourcesContent":["body, html {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n \r\n\r\n\r\n\r\n.bi-tableau-section {\r\n  width: 100%;\r\n  height: calc(100vh - 108px);  /* Adjust 108px to match your header height exactly */\r\n  min-height: 350px;\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n \r\n.tableau-viz-responsive {\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 350px;\r\n}\r\n \r\n/* .dashboard-container {\r\n  width: 99%;\r\n  max-width: 2200px;\r\n  height: 100vh;\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: -10px;\r\n  position: relative;\r\n  transform: scale(1);\r\n  transform-origin: top left;\r\n} */\r\n \r\n.dashboard-header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 4px;\r\n \r\n}\r\n.header-main{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n \r\n.header-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n \r\n}\r\n \r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n \r\n.header-right-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n \r\n.avatar {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n \r\n.chat-button-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n \r\n.back-to-dashboard-button:disabled {\r\n  pointer-events: none;    \r\n  opacity: 0.5;            \r\n  cursor: not-allowed;    \r\n}\r\n \r\n \r\n/* Overall Wrapper to force a horizontal layout */\r\n.dashboard-wrapper {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n \r\n/* Dashboard Container on the left */\r\n.dashboard-container {\r\n\r\n  flex-grow: 1;\r\n  width: 100%; /* 100% when chatbot isn't open */\r\n  height: 100vh;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: width 0.3s ease-in-out;\r\n}\r\n \r\n/* When chatbot is open, shrink dashboard to 70% */\r\n.dashboard-container.shrink-dashboard {\r\n  width: 70%;\r\n}\r\n \r\n/* Chatbot window on the right */\r\n.floating-chat-window {\r\n  width: 30%;\r\n  height: 100vh;\r\n  background-color: #fcfcfc;\r\n  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-left: 1px solid #ccc;\r\n  transition: width 0.3s ease-in-out;\r\n}\r\n \r\n/* Floating Chat Toggle Button - fixed at bottom-right */\r\n.floating-chat-toggle {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 25px;\r\n  z-index: 1000;\r\n  background: linear-gradient(to right, #4b6cb7, #182848);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  font-size: 24px;\r\n  width: 60px;\r\n  height: 60px;\r\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n}\r\n \r\n.floating-chat-toggle:hover {\r\n  background: linear-gradient(to right, #182848, #4b6cb7);\r\n}\r\n\r\n.chatbot-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n}\r\n\r\n.floating-chat-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #f5f5f5;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #ddd;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-top-left-radius: 12px;\r\n  border-top-right-radius: 12px;\r\n}\r\n\r\n.floating-chat-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: #666;\r\n  transition: color 0.2s ease-in-out;\r\n}\r\n\r\n.floating-chat-close:hover {\r\n  color: #000;\r\n}\r\n\r\n/* .floating-chat-toggle {\r\n  position: fixed;\r\n  bottom: 30px;\r\n  right: 30px;\r\n  z-index: 999;\r\n  background-color: #1e3a8a;\r\n  color: white;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  font-size: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.floating-chat-toggle::after {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: 60px; \r\n  right: 0;\r\n  transform: translateX(30%) translateY(0); \r\n  background-color: #333;\r\n  color: #fff;\r\n  padding: 6px 10px;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.2s ease;\r\n  z-index: 1000;\r\n}\r\n\r\n.floating-chat-toggle:hover::after {\r\n  opacity: 1;\r\n} */ \r\n\r\n.floating-chat-container {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  z-index: 999;\r\n  /* ensure the container can capture hover */\r\n}\r\n\r\n.floating-chat-toggle {\r\n  background-color: #1e40af;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  padding: 14px;\r\n  font-size: 22px;\r\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease;\r\n}\r\n.floating-chat-toggle:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.tooltip {\r\n  position: absolute;\r\n  bottom: 70px;    /* adjust vertical distance above the button */\r\n  right: 0;\r\n  background-color: #496cdd;\r\n  color: white;\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\r\n  \r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transform: translateY(8px);\r\n  transition: opacity 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n/* <-- This is the fix: hover on container, not on the button */\r\n.floating-chat-container:hover .tooltip {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n\r\n\r\n\r\n.dashboard-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* New: left group for dropdown/add */\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  z-index: 1;\r\n}\r\n\r\n/* New: fixed center title */\r\n.main-title-fixed {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  z-index: 0;\r\n}\r\n\r\n/* Keep right section aligned */\r\n.header-right-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* body, html {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.dashboard-wrapper {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100vh;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n}\r\n\r\n.dashboard-container {\r\n  flex-shrink: 0;\r\n  width: 100%;\r\n  max-width: 2200px;\r\n  height: 100vh;\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n/* Shrink dashboard when chat is open */\r\n/* .dashboard-wrapper.chat-open .dashboard-container {\r\n  width: 70% !important;\r\n}\r\n\r\n.dashboard-header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.header-main {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.header-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.header-right-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.avatar {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.chat-button-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.back-to-dashboard-button:disabled {\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Floating 💬 button */\r\n/* .floating-chat-toggle {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 25px;\r\n  z-index: 1000;\r\n  background: linear-gradient(to right, #4b6cb7, #182848);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  font-size: 24px;\r\n  width: 60px;\r\n  height: 60px;\r\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.floating-chat-toggle:hover {\r\n  background: linear-gradient(to right, #182848, #4b6cb7);\r\n}\r\n\r\n/* Full ChatWindow embedded on right 30% */\r\n/* .floating-chat-window {\r\n  width: 30%;\r\n  height: 100vh;\r\n  background-color: #fcfcfc;\r\n  z-index: 999;\r\n  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-left: 1px solid #ccc;\r\n} */ \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
